/**
 * `gameFlag` resolution for the 4x4 "block" VIF boards (`VIFAddSub`,
 * `VIFMulDiv`).
 *
 * Mirrors `BlockBoardEngine.initGame`'s `gameFlag = moduleId - 166 + 1`
 * (1=add, 2=sub, 3=mul, 4=div; `games/engine/blockBoardEngine.ts:105`). Only
 * `moduleVariant === 0` is the block board - the same moduleIds 166-169 at
 * other variants are unrelated 3x3 "rules" stages (see
 * `rulesAddSubFlag.ts`/`rulesMulDivFlag.ts`), so this lookup is strict about
 * both, not just `moduleId`.
 */

const MIN_BLOCK_MODULE_ID = 166;
const MAX_BLOCK_MODULE_ID = 169;
const BLOCK_MODULE_VARIANT = 0;

/**
 * Strict lookup: `null` when the module/variant pair is not a 4x4 block
 * board.
 *
 * Routing decisions must use this rather than reimplementing the range check
 * inline - widening it is how the DOM block board rollout would proceed.
 */
export function lookupBlockGameFlag(
  moduleId: number,
  moduleVariant: number,
): 1 | 2 | 3 | 4 | null {
  if (
    moduleVariant !== BLOCK_MODULE_VARIANT ||
    moduleId < MIN_BLOCK_MODULE_ID ||
    moduleId > MAX_BLOCK_MODULE_ID
  ) {
    return null;
  }

  return (moduleId - MIN_BLOCK_MODULE_ID + 1) as 1 | 2 | 3 | 4;
}
